import { render, staticRenderFns } from "./RevenueListHandler.vue?vue&type=template&id=1404435e"
import script from "./RevenueListHandler.vue?vue&type=script&lang=ts"
export * from "./RevenueListHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports